export default __webpack_public_path__ + "static/media/mobile.2a205709.jpg";